import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  userProfileCard: ({ typography }) =>
    css`
      margin-bottom: 20px;
      width: 100%;
      height: auto;
      box-sizing: border-box;
      font-family: ${typography.label.fontFamily};

      > div {
        width: 100%;
      }

      @media (min-width: 640px) {
        display: flex;
        align-items: center;
        width: 80%;
      }
    `,

  itemsCard: css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  `,

  avatarCard: css`
    display: none;
    width: 48px;
    height: 48px;
    align-items: center;

    @media (min-width: 640px) {
      display: flex;
    }
  `,

  cardWrapper: ({ spacing }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${spacing.xs};
  `,

  nameCard: ({ typography, colors }) => css`
    display: inline-block;
    font-family: ${typography.label.fontFamily};
    color: ${colors.neutral[400]};
    text-transform: capitalize;
  `,

  clinicCard: ({ colors }) => css`
    color: ${colors.neutral[300]};
  `,

  iconCard: ({ spacing }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    @media (max-width: 639px) {
      margin-left: ${spacing.xxs};
    }
  `,

  specialityCard: ({
    colors,
    typography,
    spacing,
    fontSizes,
    fontWeights,
  }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: ${spacing.xxs};
    color: ${colors.neutral[500]};
    text-align: left;
    font-weight: ${fontWeights.normal};
    font-size: ${fontSizes.sm};
    line-height: 24px;
    cursor: pointer;
    font-family: ${typography.label.fontFamily};

    p {
      min-width: 230px;
      display: flex;
      align-items: center;
      gap: ${spacing.xxs};

      &::before {
        content: '';
        width: 4px;
        height: 4px;
        background-color: black;
        display: block;
        border-radius: 50%;
      }
    }

    @media (max-width: 639px) {
      flex-direction: column;
      width: 100%;
    }
    > div {
      display: flex;
      min-width: 230px;
      @media (max-width: 639px) {
        width: 100%;
      }
      p {
        min-width: 230px;
        display: flex;
        align-items: center;
        gap: ${spacing.xxs};
        &::before {
          content: '';
          width: 4px;
          height: 4px;
          background-color: black;
          display: block;
          border-radius: 50%;
        }
      }
    }
  `,
  textCard: ({ colors, spacing, fontSizes }) => css`
    p {
      color: ${colors.brand.primary[300]};
      font-style: normal;
      font-weight: 700;
      font-size: ${fontSizes.md};
      margin-bottom: ${spacing.xs};
      line-height: 24px;
    }
  `,
})

export default useStyles
